<template>
    <BreadCrumb PageTitle=" Ajouter une facture" />
    <AddFacture/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddFacture from "@/components/Facture/AddFacture.vue";
  
    export default defineComponent({
      name: "AddFacturePage",
      components: {
        BreadCrumb,
        AddFacture,
      },
    });
  </script>